<header mat-dialog-title class="u-flex-full">
  <span>
    <span *ngIf="riskArea">{{'risks.Modifica area di rischio' | translate}} : {{riskArea.name}}</span>
    <span *ngIf="!riskArea">{{'risks.Nuova area di rischio' | translate}}</span>
  </span>
  <span *ngIf="riskArea">
    <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
      <button mat-menu-item (click)="deleteRiskArea()">
        <mat-icon>delete</mat-icon>
        {{'shared.Elimina' | translate}}
      </button>
    </mat-menu>
  </span>
</header>
<mat-dialog-content>
  <form [formGroup]="riskAreaForm" novalidate>
    <div class="u-flex-full">
    <mat-form-field class="u-full-width">
      <input matInput placeholder="{{'shared.Nome' | translate}}" formControlName="name" type="text" >
      <mat-error>{{'shared.Campo obbligatorio' | translate}}</mat-error>
    </mat-form-field>
     </div>
  </form>
    <!-- {{riskAreaForm.value | json}} -->

</mat-dialog-content>
<mat-dialog-actions class="u-flex-full">
  <span>
    <button mat-raised-button color="basic" type="reset" (click)="revert()"
      [disabled]="riskAreaForm.pristine">{{'shared.Reset' | translate}}</button>
    <button mat-raised-button color="primary" (click)="save()"
      [disabled]="riskAreaForm.pristine || !riskAreaForm.valid">{{'shared.Salva' | translate}}</button>
    <span class="fill-remaining"></span>
  </span>
  <button mat-raised-button color="basic" type="button" (click)="close()">{{'shared.Chiudi' | translate}}</button>
</mat-dialog-actions>
